import Grid from '@mui/material/Grid';
import { Button } from '@openx/components-core/lib/Button/Button.tsx';
import type { ContentObjectAction, ContentObjectOption } from '@openx/types/targeting/contentObject.ts';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { BulkAddDrawer } from '../../../shared/BulkAdd/BulkAddDrawer.tsx';
import { useBulkAdd } from '../../../shared/BulkAdd/useBulkAdd.ts';
import { bulkInputPlaceholder, getOptionName } from '../../constants.ts';
import { validateBulkTextFields } from '../utils.ts';

type FreeTextBulkAddProps = {
  dispatch: (action: ContentObjectAction) => void;
  selectedItems: Set<string>;
  type: ContentObjectOption;
};

export const FreeTextBulkAdd = ({ dispatch, selectedItems, type }: FreeTextBulkAddProps) => {
  const { t } = useTranslation();

  const addBulkItems = useCallback((values: string[]) => dispatch({ type, values }), [dispatch, type]);

  const { isBulkOpen, onBulkAdd, onBulkClose, onBulkOpen } = useBulkAdd<string[]>({ onAdd: addBulkItems });

  const validateBulk = useCallback(
    (values: string[]) => Promise.resolve(validateBulkTextFields(values, selectedItems)),
    [selectedItems]
  );

  return (
    <>
      <Grid size={12}>
        <Button data-test="content-object-bulk-add-button" onClick={onBulkOpen}>
          {t('Bulk Add')}
        </Button>
      </Grid>

      {isBulkOpen ? (
        <BulkAddDrawer
          title={t('Bulk Add {optionName}', { optionName: getOptionName(type) })}
          onApply={onBulkAdd}
          onClose={onBulkClose}
          placeholder={bulkInputPlaceholder(type)}
          validate={validateBulk}
        />
      ) : null}
    </>
  );
};
